document.addEventListener('shopify:section:unselect', (event) => {
  var sectionId = event.detail.sectionId;
  if (window.splideInstances[ sectionId ]) {
    window.splideInstances[ sectionId ].Components.Autoplay.play();
  }
});

document.addEventListener('shopify:section:load', (event) => {
  var sectionId = event.detail.sectionId;
  if (window.splideInstances[ sectionId ]) {
    window.splideInstances[ sectionId ].destroy(true);
    window.splideInstances[ sectionId ] = new Splide("#splide-slide-" + sectionId, window.splideOptions[ sectionId ]).mount();
    window.splideInstances[ sectionId ].Components.Autoplay.pause();
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  var sectionId = event.detail.sectionId;
  if (window.splideInstances[ sectionId ]) {
    window.splideInstances[ sectionId ].destroy(true);
    window.splideInstances[ sectionId ] = new Splide("#splide-slide-" + sectionId, window.splideOptions[ sectionId ]).mount();
  }
});

document.addEventListener('shopify:block:select', (event) => {
  var sectionId = event.detail.sectionId;
  var blockId = event.detail.blockId;
  var block = document.querySelectorAll('[data-block-id="' + blockId + '"]');
  if (window.splideInstances[ sectionId ] && block.length > 0) {
    var index = block[ 0 ].getAttribute("data-block-index");
    window.splideInstances[ sectionId ].Components.Autoplay.pause();
    window.splideInstances[ sectionId ].go(parseInt(index, 10));
  }
});

/*document.addEventListener('shopify:block:unselect', (event) => {
  var sectionId = event.detail.sectionId;
  if (window.splideInstances[ sectionId ]) {
    window.splideInstances[ sectionId ].Components.Autoplay.play();
  }
});*/
